import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { Sparkles, Gift } from 'lucide-react';
const products = [{
  image: 'https://cdn.magicpatterns.com/uploads/bFTiCyeouR5xETbXNJtFNu/ChatGPT_Image_5_feb_2026,_11_35_43.png',
  title: 'Audiolibro Completo',
  description: 'Escucha y transforma tu mente'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/cZL3pXspR9iE4oZtgNYxPi/SISTEMA_ANTICAOS_COVER_1_optimizada.png',
  title: 'Libro Digital',
  description: 'Sistema Anticaos™'
}];
export function ProductShowcaseSection() {
  return <Section id="experiencia-angelical" className="bg-transparent relative overflow-hidden" data-id="element-171">
      <div className="relative z-10" data-id="element-172">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-173">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-black/50 backdrop-blur-sm border border-[#D4AF37]/30 mb-6" data-id="element-174">
            <Sparkles className="w-5 h-5 text-[#D4AF37]" data-id="element-175" />
            <span className="text-[#D4AF37] font-medium" data-id="element-176">Todo Incluido</span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-3xl md:text-5xl font-bold text-white mb-4 drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]" data-id="element-177">
            Una{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D4AF37] to-[#F5D76E]" data-id="element-178">
              Experiencia Angelical
            </span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-gray-200 max-w-2xl mx-auto drop-shadow-[0_2px_8px_rgba(0,0,0,0.9)]" data-id="element-179">
            Todo esto puedes adquirirlo para transformar tu vida con disciplina
            divina
          </motion.p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 mb-12 max-w-2xl mx-auto" data-id="element-180">
          {products.map((product, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group" data-id="element-181">
              <div className="relative aspect-square rounded-2xl overflow-hidden bg-black/40 backdrop-blur-sm border border-[#D4AF37]/20 mb-4 shadow-xl" data-id="element-182">
                <img src={product.image} alt={product.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-183" />
                {/* Overlay gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-184" />
              </div>
              <h3 className="text-lg font-bold text-white mb-1 drop-shadow-[0_1px_3px_rgba(0,0,0,0.8)]" data-id="element-185">
                {product.title}
              </h3>
              <p className="text-sm text-gray-300" data-id="element-186">{product.description}</p>
            </motion.div>)}
        </div>

        {/* Bundle Badge */}
        <motion.div id="paquete-completo" initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex justify-center" data-id="element-187">
          <a href="https://pay.hotmart.com/M104286251F?bid=1770346803141" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 px-6 py-4 rounded-2xl bg-black/60 backdrop-blur-md border border-[#D4AF37]/40 shadow-2xl hover:border-[#D4AF37]/70 hover:shadow-[0_0_30px_rgba(212,175,55,0.3)] transition-all duration-300 cursor-pointer" data-id="element-188">
            <Gift className="w-8 h-8 text-[#D4AF37]" data-id="element-189" />
            <div className="text-left" data-id="element-190">
              <p className="text-white font-bold drop-shadow-[0_1px_3px_rgba(0,0,0,0.8)]" data-id="element-191">
                ¡Ordenar mi Caos Ya!
              </p>
            </div>
            <div className="ml-4 px-4 py-2 rounded-lg bg-[#D4AF37]/20" data-id="element-192">
              <span className="text-2xl font-black text-[#D4AF37]" data-id="element-193">
                $111.19 MXN
              </span>
            </div>
          </a>
        </motion.div>
      </div>
    </Section>;
}